var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedininline = function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.156 18V6.32H.523V18h3.633ZM2.32 4.758c1.172 0 2.11-.977 2.11-2.149 0-1.132-.938-2.07-2.11-2.07A2.085 2.085 0 0 0 .25 2.61c0 1.172.938 2.149 2.07 2.149ZM17.71 18h.04v-6.406c0-3.125-.703-5.547-4.375-5.547-1.758 0-2.93.976-3.438 1.875h-.039V6.32H6.422V18h3.633v-5.781c0-1.524.273-2.969 2.148-2.969s1.914 1.719 1.914 3.086V18h3.594Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedininline;